<template>
  <div>
    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
          rules="required|email"
          name="Email"
        >
          <v-text-field
            id="form-text-field-email"
            v-model="userData.email"
            label="Email"
            placeholder="Введите Email"
            outlined
            dense
            :error-messages="errors"
            :readonly="readonly"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <validation-provider v-slot="{ errors }" rules="required" name="Имя">
          <v-text-field
            id="form-text-field-name"
            v-model="userData.name"
            label="Имя"
            placeholder="Введите имя пользователя"
            outlined
            dense
            maxlength="50"
            :error-messages="errors"
            :readonly="readonly"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row
      v-show="
        !readonly &&
          toggleEditPasswordVisible &&
          ($can('Passwords/view') || !isEditAction)
      "
      dense
    >
      <v-col>
        <span
          id="form-btn-toggle-password-change"
          class="sv-toggler mb-2"
          @click="onChangePasswordSwitch()"
        >
          {{ userData.change_password ? "Не менять пароль" : "Сменить пароль" }}
        </span>
      </v-col>
    </v-row>

    <v-row
      v-show="
        !readonly &&
          canEditPassword &&
          ($can('Passwords/view') || !isEditAction)
      "
      dense
    >
      <v-col>
        <validation-provider
          v-slot="{ errors }"
          :rules="{ required: canEditPassword, strong_password: true }"
          name="Пароль"
        >
          <v-text-field
            id="form-text-field-password"
            v-model="userData.password"
            outlined
            dense
            :error-messages="errors"
            placeholder="Введите пароль"
            label="Пароль"
            :append-icon="
              userData.visible_password
                ? 'mdi-eye-off-outline'
                : 'mdi-eye-outline'
            "
            :type="userData.visible_password ? 'text' : 'password'"
            :disabled="!canEditPassword"
            @click:append="
              userData.visible_password = !userData.visible_password
            "
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <validation-provider v-slot="{ errors }" rules="required" name="Роли">
          <v-autocomplete
            id="form-autocomplete-roles"
            v-model="userData.roles"
            label="Роли"
            multiple
            dense
            outlined
            chips
            deletable-chips
            small-chips
            item-text="title"
            item-value="id"
            :error-messages="errors"
            :items="roles"
            :readonly="readonly"
            class="sv-autocomplete"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-textarea
          id="form-text-field-add-info"
          v-model="userData.add_info"
          label="Дополнительная информация"
          outlined
          dense
          maxlength="200"
          counter="200"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import { computed } from "vue";

export default {
  mixins: [CheckPermissionMixin],

  props: {
    value: {
      type: Object,
      required: true
    },
    roles: {
      type: Array,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true
    }
  },

  setup(props, { emit }) {
    const userData = computed({
      get: () => props.value,
      set: val => emit("input", val)
    });

    const isCreateAction = computed(() => props.action === "create");
    const isEditAction = computed(() => props.action === "edit");

    const toggleEditPasswordVisible = computed(() => {
      return isEditAction.value;
    });

    const canEditPassword = computed(() => {
      return isEditAction.value ? userData.value.change_password : true;
    });

    const onChangePasswordSwitch = () => {
      userData.value.password = "";
      userData.value.change_password = !userData.value.change_password;
    };

    return {
      userData,
      onChangePasswordSwitch,
      isCreateAction,
      isEditAction,
      canEditPassword,
      toggleEditPasswordVisible
    };
  }
};
</script>
